var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":`transition ${_vm.duration} ${_vm.delay}`,"enter-class":"translate-y-full","enter-to-class":"translate-y-0","leave-active-class":"transition duration-300","leave-class":"translate-y-0","leave-to-class":"translate-y-full"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }